import React from "react";
import "./Privacy.css";

function Privacy() {
  return (
    <div className="privacy">
      <div className="container">
        <div className="privacy_text">
          <h1 style={{ color: "black" }}>Privacy Policy</h1>
          <hr />
          <p>
            This Privacy Policy is designed to inform users of the K'Bro, Inc.
            ("K'Bro") website (www.KBro.io), mobile application and services
            (collectively, the "Services" or "Service") about how we gather and
            use personal information collected by us in connection with use of
            the Service. You may have been invited to use, download or install
            the Service from a third party as part of an ongoing study or
            research project or your healthcare provider (such third party, the
            "Institutional Client"), or you may have subscribed or downloaded
            and installed the Service for your personal use. Institutional
            Client may also mean an independent third party healthcare provider
            whose services are provided through the K'Bro mobile application.
            This Privacy Policy applies to the Services. This Privacy Policy
            also applies to any services provided by third parties (such as an
            Institutional Client) and delivered by or through the K'Bro
            Services. We will take reasonable steps to protect user privacy
            consistent with the guidelines set forth in this Privacy Policy and
            with applicable U.S. laws. In this Privacy Policy, "user" or "you"
            means any individual using the Service, whether by downloading or
            browsing the Service, registering with us by creating an account, or
            participating in any other activities available through the Service.
          </p>
          <p>
            By accessing or using the service, you acknowledge that you have
            read, understand, and agree to be bound by this privacy policy and
            our terms of service. If you do not agree to these terms, do not use
            the service. For purposes of this privacy policy, "we", "us" and
            "our" may refer to k'bro, an institutional client, or both, as
            applicable.
          </p>
          <h2>What information do we collect?</h2>

          <h4>User Interaction Data</h4>
          <p>
            We may use mobile tracking technologies such as cookies, web
            beacons, pixel tags and clear GIFs, as well as embedded code in the
            Services itself, in order to operate the Service efficiently, and to
            collect data related to your usage of and interaction with the
            Service, and general use and interaction with your mobile device.
            All such collected data (collectively, "User Interaction Data") may
            include how and when you use your mobile device for communications
            with others, including mobile phone and text use, and your location
            and speed of movement while you use your mobile device. Such User
            Interaction Data may also include, but is not limited to, call
            information, SMS information (see Safeguards below), location
            samples, accelerometer samples, smartphone actions, and smartphone
            screen-time related to, or resulting from, your use of the Services.
            We do not access or collect the content of your mobile phone
            communications, such as conversations or text messages.
          </p>

          <h4>User Survery Data; Personal Information</h4>
          <p>
            We collect the following personal information in connection with the
            Service: (a) when you register to use the Service, whether in your
            individual capacity or on behalf of an organization, we may collect
            the personal information that is disclosed on our online
            registration form, such as your name, email address and other
            information detailed therein (the "Account Data"); (b) if you
            communicate with us by email, we will collect your email address;
            and (c) if you use the Services to respond to surveys and questions
            from an Institutional Client, we may collect the information you
            provide in your responses, such as health information (if any) (the
            "User Survey Data"). Such User Survey Data includes, but is not
            limited to, your answers or submissions to study surveys and health
            questionnaires, inferred health status for specific conditions, and
            survey alerts. The User Survey Data, together with the User
            Interaction Data, is referred to as "Unprocessed User Data." We may
            also collect certain demographic information, such as age and
            gender, that may be disclosed by you. All of the Account Data,
            e-mail addresses, demographic information, and Unprocessed User Data
            is referred to in this Policy as "Personal Information". Any health
            information that you provide is safeguarded in accordance with
            applicable U.S. laws.
          </p>

          <h2>How do we use the information we collect?</h2>

          <h4>Creation of Processed Data</h4>
          <p>
            K'Bro may use its proprietary technology and the Unprocessed User
            Data to compile personalized behavioral features known as K'Bro
            Behavior Feature(s) ("KBF") for each user. Such KBF analysis, and
            other data processed from Unprocessed User Data (collectively, the
            "Processed User Data"), may be summarized or otherwise set forth in
            one or more written report(s) (the "Reports"). Such Processed User
            Data and Reports may be delivered to the applicable Institutional
            Client (and/or to you within the mobile application or through the
            applicable Service to the extent K'Bro provides such delivery as
            part of the applicable Service). The applicable Institutional Client
            may also be provided with User Survey Data.
          </p>

          <h4>Use of Personal Information</h4>
          <p>
            We will use and store Personal Information for the purpose of
            delivering the Service to you and, where applicable, to
            Institutional Clients, and to analyze and enhance the operation of
            the Service. We also store and use Personal Information and, where
            applicable, any information obtained from Institutional Clients for
            proprietary analysis and development of personalized KBF for you
            and/or, where applicable, the Institutional Client. Personal
            Information may also be used for the internal operational and
            administrative purposes of the Service. We will not sell or use
            Personal Information for purposes other than what is authorized
            pursuant to your End User License Agreement ("Terms of Use"). For
            example, we will not sell your identifying Personal Information to
            third party direct marketers or advertisers. In order to share
            insights across Institutional Clients, allow for additional research
            and product development, and to garner insights about the data that
            we gather over time, K'Bro may anonymize your Personal Information,
            or de-identify your health information in a way that meets the
            Health Insurance Portability and Accountability Act of 2996 (HIPAA)
            de-identification standard, so that the data will no longer be
            identifiable to you.
          </p>

          <h4>Aggregate Information</h4>
          <p>
            We will create statistical, aggregated data relating to our users
            and the Service for analytical purposes. Aggregated data includes
            data derived from Personal Information and obtained by K'Bro from
            other sources in aggregated, anonymous form and does not identify
            any individual (such data, "Aggregate Information"). Subject to
            applicable laws and regulations, we use Aggregate Information to
            understand our customer base and to develop, improve and/or market
            our Services. We may provide Aggregate Information to third parties.
          </p>

          <h4>Legal Exception</h4>
          <p>
            Under certain circumstances, Personal Information may be subject to
            disclosure pursuant to judicial or other government subpoenas,
            warrants, or orders. As such, notwithstanding the above, we may in
            any event use Personal Information, Aggregate Information and any
            other information collected and created through the Service to the
            extent required by law or legal process, to resolve disputes, to
            enforce our agreements (including this Privacy Policy and the Terms
            of Use) with you, or if in our reasonable discretion use is
            necessary to protect our legal rights, to protect you against
            self-harm, or to protect third parties.
          </p>
          <h4>Email and Other Communications</h4>
          <p>
            If you register and provide your email address, we may send you
            administrative emails. If you wish to opt out of these emails, you
            may do so by following the "unsubscribe" instructions in the email;
            provided however, K'Bro may maintain the right to send you important
            emails about your account or the Services. Email and text messaging
            allows healthcare providers to exchange information efficiently for
            the benefit of users/patients. At the same time, we recognize that
            email and text messaging are not a completely secure means of
            communication because these messages can be addressed to the wrong
            person or accessed improperly while in storage or during
            transmission. Your use of the Service means that you agree and
            consent to the use of email and/or text messaging as an acceptable
            form of communication.
          </p>
          <h4>User Testimonials</h4>
          <p>
            We value your feedback on, and appreciate any testimonials about,
            our Services. If you send us any such feedback or testimonials, they
            shall be deemed, and shall remain, the property of K'Bro and none
            shall be subject to any obligation of confidence on our part.
            However, K'Bro shall obtain prior written approval of any usage of
            your identity or contact information, if K'Bro wishes to reference
            you in connection with that feedback or testimonial.
          </p>

          <h2>Which information do we disclose to third parties?</h2>

          <h4>Personal Information</h4>
          <p>
            We will not disclose your identifying Personal Information,
            including identifiable health information, to any third party except
            as follows: (i) K'Bro may disclose your Personal Information to an
            Institutional Client on whose behalf the information was collected.
            (ii) K'Bro may disclose your Personal Information to third party
            contractors engaged to provide services on our behalf
            ("Contractors"), such as performing marketing, analyzing data and
            usage of the Service, operating the Service or providing support and
            maintenance services for the Service, or providing customer service.
            We enter into confidentiality agreements with all Contractors that
            require Contractors to use the Personal Information they receive
            only to perform services for us. (iii) K'Bro may otherwise disclose
            your Personal Information when we have your consent to share the
            information. In such cases, we will have written contracts in place
            with the third parties requiring them to comply with terms of
            confidentiality similar to the applicable terms of this Privacy
            Policy as well as all applicable statutes, regulations and laws
            pertaining to the protection of such Personal Information.
          </p>
          <h4>Aggregate Information</h4>
          <p>
            We may disclose Aggregate Information (which has been de-identified)
            to third parties, such as the Institutional Client, potential
            customers, business partners, advertisers, and funding sources, as
            part of our business and operations. We may also license, sell, or
            otherwise use or provide Aggregate Information.
          </p>
          <h4>Network Operators</h4>
          <p>
            Use of the Service may involve use of the services of third party
            telecommunications carriers. Such carriers are not our contractors,
            and any information that a carrier collects in connection with your
            use of the Service is not "Personal Information" and is not subject
            to this Privacy Policy. We are not responsible for the acts or
            omissions of telecommunications carriers.
          </p>
          <h4>Additional Disclosures</h4>
          <p>
            We reserve the right to disclose any information we collect in
            connection with the Service, including Personal Information, (a) to
            a subsidiary or parent company or to any successor to our business
            as a result of any merger, acquisition, asset sale or similar
            transaction; and (b) to any law enforcement, judicial authority, or
            governmental or regulatory authority, to the extent required by law
            or if in our reasonable discretion disclosure is necessary to
            enforce or protect our legal rights, to protect you, or to protect
            third parties.
          </p>
          <h4>Third Parties</h4>
          <p>
            We reserve the right to use third parties to provide or support the
            Service. These third parties are used to provide a more efficient
            service to users/patients. Such third parties have their own
            policies and procedures around information security. Your use of the
            Service means that you agree and consent to the security and privacy
            policies of such third parties.
          </p>

          <h2>Accessing and updating your personal information</h2>

          <p>
            Whenever you use our Services, we aim to provide you with access to
            your Personal Information. If that information is wrong, we strive
            to give you ways to update it quickly, or to delete it - unless we
            have to keep that information for legitimate business or legal
            purposes. You may send us an email to help@KBro.io requesting that
            we remove your account and delete all of your Personal Information,
            that we stop collecting data from your mobile phone, or to otherwise
            provide us with the necessary changes to update your Personal
            Information. We aim to maintain our Services in a manner that
            protects information from accidental or malicious destruction.
            Subject to applicable law and necessary record retention
            requirements, your identifying Personal Information shall be deleted
            from our records within 90 days of your request or the termination
            of the Terms of Use you enter with us. Notwithstanding, we have the
            right to continued use of any Aggregate Information or de-identified
            information even if we have deleted the underlying Personal
            Information. Furthermore, even when your Personal Information is
            deleted from K'Bro's system, you acknowledge data is not removed
            from existing KBFs, the Processed User Data or Reports that were
            built off of that data, including without limitation those that may
            have been previously provided to Institutional Clients.
          </p>

          <h2>Privacy settings</h2>
          <p>
            K'Bro is happy to allow you to review or amend your email address or
            account information held in our database. Please contact us by
            sending an email to: help@KBro.io. If you would like your account
            permanently removed from our database, please contact us at
            help@KBro.io. We will then terminate your account, and you will no
            longer receive emails from K'Bro. Termination of your account will
            not result in the deletion of any Aggregate Information and
            de-identified information that K'Bro holds relating to you, and we
            will retain this information and may use and disclose it in
            accordance with this Privacy Policy. As stated above, applicable
            laws may require K'Bro to retain certain information following
            termination of your account. K'Bro may still contact users who have
            deleted their information for administrative purposes in connection
            with the Services.
          </p>

          <h2>General security</h2>

          <h4>Security</h4>
          <p>
            We use reasonable security precautions to protect the security and
            integrity of your Personal Information in accordance with this
            Privacy Policy and applicable law. However, no Internet transmission
            is completely secure, and we cannot guarantee that security breaches
            will not occur. Without limitation of the foregoing, we are not
            liable for the actions of hackers and other unauthorized third
            parties that breach our security procedures. Nor are we responsible
            for other breaches to your Personal Information outside our control,
            such as resulting from loss, theft or unauthorized use of your
            mobile device or third party systems. You are responsible for
            maintaining the security of your login ID and password. If you
            believe that your login ID or password have been compromised you
            should immediately change your password and contact support. We are
            not responsible if someone else accesses your account through
            registration information they have obtained from you or through a
            violation by you of this Privacy Policy or your Terms of Use.
          </p>
          <h4>Safeguards</h4>
          <p>
            We have implemented the following technical safeguards to minimize
            the potential risk of a privacy breach: - During analysis, data is
            linked only to coded identifiers for the participants, and not to
            any personal identifiers. - Contents of SMS messages or phone calls
            are not captured. Only SMS and phone call events are logged. -
            Incoming and outgoing phone numbers and names from your contacts are
            stored encrypted. - Raw audio is not captured or stored. - Email
            addresses used during the Mobile Application install process and to
            send notifications will be inaccessible for analysis, and stored in
            encrypted form.
          </p>
          <h4>Links</h4>
          <p>
            The K'Bro Service may contain links to other websites. K'Bro is not
            responsible for the privacy practices or the content of those
            websites. Users should be aware of this when they leave our Service
            and are encouraged to review the privacy statements of each third
            party website. This Privacy Policy applies solely to information
            collected by Us.
          </p>
          <h4>Amendments</h4>
          <p>
            We may modify or amend this Privacy Policy from time to time. If we
            make any material changes, as determined by K'Bro, in the way in
            which Personal Information is collected, used or transferred, such
            changes to this Privacy Policy will be available via a link to the
            most current terms of the Privacy Policy (which can be found at
            K'Bro's website for the Services). Notwithstanding any modifications
            we may make, any identifying Personal Information collected by Us
            from you will be treated subject to applicable laws and regulations.
            The date last revised appears at the bottom of the Privacy Policy.
            Changes take effect immediately upon posting.
          </p>
          <h4>Do Not Track Browser Requests</h4>
          <p>
            K'Bro does not use services that track your behavior across the Web.
            Therefore, our Service does not alter its behavior or change its
            services upon receiving Do Not Track requests from your web browser.
          </p>
          <h4>Children</h4>
          <p>
            K'Bro does not knowingly collect or maintain personally identifiable
            information from persons under 12 years of age, and no part of the
            Service is directed at persons under 12. If you are under 12 years
            of age, then please do not use the Service. If K'Bro learns that
            personally identifiable information of persons less than 12 years of
            age has been collected without verifiable parental consent, then
            K'Bro will take the appropriate steps to delete this information. To
            make such a request, please contact us at help@KBro.io.
          </p>
          <h4>General Inquiries and Concerns</h4>
          <p>
            To submit a general inquiry or concern, please contact us at
            help@KBro.io or write to us at the following address: K'Bro, Inc.
            c/o Customer Support - Privacy Policy 3122 Barney Avenue, Menlo
            Park, CA 94025.
          </p>
          <h4>Service Visitors from Outside the United States</h4>
          <p style={{ marginBottom: "40px" }}>
            K'Bro and its servers are located in the United States and are
            subject to the applicable state and federal laws of the United
            States. If you choose to access or use the Service, you consent to
            the use and disclosure of information in Boos accordance with this
            Privacy Policy and subject to such laws.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
